<template>
    <v-container fluid>
        <v-card flat>
            <strong>Aún no ha validado su correo. Favor revise el correo ingresado al registrarse y siga las instrucciones. Una
                vez que valide su correo debe intentar nuevamente el ingreso con su rut y contraseña.</strong>
        </v-card>
    </v-container>
</template>

<script>
export default {
    name: "validate"
}
</script>

<style scoped>

</style>
